import React, { useState, forwardRef, useImperativeHandle, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { Toast } from "primereact/toast";
import MeaButton from "../../../../components/MeaButton";
import studentsAPI from "../../../../services/students";

const ConfirmRegistrationModal = forwardRef((props, ref) => {
  const { schoolId, trainingId, memberId } = props;
  const accessToken = "";

  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [students, setStudents] = useState([]);
  const [details, setDetails] = useState("");
  const [callbackFn, setCallbackFn] = useState(() => {});
  const toast = useRef(null);

  useImperativeHandle(ref, () => ({
    show: (studentsList, callback, initialDetails = "") => {
      setStudents(studentsList || []);
      setDetails(initialDetails || "");
      setCallbackFn(() => callback);
      setVisible(true);
    },
    hide: () => {
      setVisible(false);
    }
  }));

  const handleConfirm = async () => {
    setLoading(true);
    try {
      // Loop over students and update status to ENROLLED with details
      for (const student of students) {
        await studentsAPI.UpdateStatus(
          schoolId,
          trainingId,
          accessToken,
          student.id,
          "ENROLLED",
          memberId,
          details
        );
      }
      toast.current.show({
        severity: "success",
        summary: "Succès",
        detail: "Inscription(s) confirmée(s) avec succès !",
        life: 1500
      });
      setTimeout(() => {
        setVisible(false);
        setLoading(false);
        if (callbackFn) callbackFn();
      }, 1200);
    } catch (err) {
      console.error(err);
      toast.current.show({
        severity: "error",
        summary: "Erreur",
        detail: err.message || "Une erreur est survenue."
      });
      setLoading(false);
    }
  };

  const footerContent = (
    <div>
      <MeaButton
        label="Annuler"
        icon="pi pi-times"
        disabled={loading}
        onClick={() => setVisible(false)}
        className="p-button-text"
      />
      <MeaButton
        label="Confirmer"
        icon="pi pi-check"
        loading={loading}
        onClick={handleConfirm}
      />
    </div>
  );

  return (
    <>
      <Toast ref={toast} position="bottom-center" />
      <Dialog
        focusOnShow={false}
        header="Confirmer l'inscription"
        visible={visible}
        style={{ width: "35vw" }}
        breakpoints={{ "960px": "75vw", "641px": "100vw" }}
        onHide={() => {
          if (!loading) setVisible(false);
        }}
        footer={footerContent}
      >
        <div className="w-full">
          <div className="flex flex-column gap-2 mt-2">
            <p className="m-0 text-700">
              Veuillez saisir les détails ou commentaires de confirmation d'inscription pour{" "}
              {students.length > 1
                ? `les ${students.length} élèves sélectionnés`
                : students[0]?.firstname
                ? `${students[0].firstname} ${students[0].lastname}`
                : "l'élève"} :
            </p>
            <InputTextarea
              value={details}
              onChange={(e) => setDetails(e.target.value)}
              rows={4}
              autoResize
              placeholder="Détails, commentaires ou notes de confirmation d'inscription..."
              className="w-full mt-2"
            />
          </div>
        </div>
      </Dialog>
    </>
  );
});

export default ConfirmRegistrationModal;
